module.exports = __webpack_public_path__ + "img/奖章2级@2x.3c9ef015.png";